import "./SocialLogo.scss";
import { Link } from 'react-router-dom';

const SocialLogo = () => {
    return (
        <Link className='link-logo' to='/'>AEP</Link>
    );
}

export default SocialLogo;